import React, { useEffect, useState } from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid";
import { PolicyAdditionalInterestDto } from "../../../model/PolicyAdditionalInterestDto";
import { CustomerPolicyDetailLabels as cstPolicyAdditionalInterestsLabels } from '../../../../shared/util/label';
import { fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import { Checkbox } from "../../../../components";

export interface ICustomerPolicyAdditionalInterests {
  policyAdditionalInterests: PolicyAdditionalInterestDto[];
}

const CustomerPolicyAdditionalInterests: React.FunctionComponent<ICustomerPolicyAdditionalInterests> = (props) => {

  const columns: any[] = [
    {
      Header: cstPolicyAdditionalInterestsLabels.RANK,
      accessor: "rank",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 150,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.ATTACH_TYPE,
      accessor: "attachTypeValue",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 150,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.ATTACH_VALUE,
      accessor: "attachValue",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 250,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.ADDITIONAL_INTEREST_NAME,
      accessor: "name",
      Cell: row => {
        const { name1, name2 } = row.row.original; 
        const computedName = name1 && name2
          ? `${name1} ${name2}`
          : name1 || name2 || "";
        
        return <div><span title={computedName}>{computedName}</span></div>;
      },
      width: 350,
      cellClassName:"",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.ADDRESS,
      accessor: "address",
      Cell: row => {
        const { address1, address2 } = row.row.original; 
        const computedAddress = address1 && address2
          ? `${address1} ${address2}`
          : address1 || address2 || "";
        
        return <div><span title={computedAddress}>{computedAddress}</span></div>;
      },
      width: 350,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.CITY,
      accessor: "city",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.STATE,
      accessor: "state",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 150,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.ZIP_CODE,
      accessor: "zip",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.LOAN_NUMBER,
      accessor: "referenceNumber",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 200,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyAdditionalInterestsLabels.PAYOR,
      accessor: "isPayor",
      Cell: row => {
        const { id, isPayor } = row.row.original || {};
        return (
          <div>
            <Checkbox
              id={`payorCheckbox-${id ?? row.row.index}`}
              disabled={true}
              label=""
              checked={!!isPayor}
            />
          </div>
        );
      },
      width: 200,
      cellClassName: "",
      headerClassName: ""
    },
  ];

  return (
    <PolicyGrid
      hiddenColumns={["id"]}
      data={props.policyAdditionalInterests}
      columns={columns}
      gridId="policyAdditionalInterestsGrid"
      disableSorting ={true}
      noRecordsMessage={PolicySummaryErrorMessages.NO_ADDITIONAL_INTERESTS_FOUND}/>
  );
};

export default CustomerPolicyAdditionalInterests;
